

import { PirBoxProductsDetails } from "../../../model/pirbox/pir-box-product-detail";
import { PirBoxProductSummary } from "../../../model/pirbox/pirbox-product-summary";
import { YearlyPirIndicatorsBean } from "../../../api/generated/objectway-zenith";

export type PirBoxError = 'GENERIC_ERROR';

export interface PirBoxState {
    status: string,
    error: string,
    positions?: Map<string, PirBoxProductsDetails[]>,
    productsSummary?: PirBoxProductSummary[],
    hasOrdinary?: boolean,
    hasAlternative?: boolean,
    selectedMandateCode: string,
    graphDetails?: YearlyPirIndicatorsBean;
}

export interface PirBoxRapportiPadre {
    codRapporto?: string,
    dataScadenzaPirBox?: string | null

}


export enum PirTypesEnum {
  Alternative = 'FIA',
  Ordinario = 'UCITS'
}

export enum PirTypesEnumReverse{
  FIA = 'Alternative',
  UCITS = 'Ordinario'
}

export enum PirPositionTypesEnum{
  Qualificata = 'COMPLIANT',
  NonQualificata = 'NOT_COMPLIANT'
}
